export enum EmployeeTypes {
  Dealer = 'dealer',
  Employee = 'Employee',
  Distributor = 'Distributor',
  Shared = 'Shared',
  LineConsultant = 'Line consultant',
  Consultant = 'Consultant',
}

export enum DealerErrorType {
  UnauthorizedDealer = 'AUTH:api.error.dealerUnauthorized',
  ForbiddenDealer = 'AUTH:api.error.dealerForbidden',
}